import schema from '@/framework/logic/schema/batch-layout-operations.schema.json';
import interpolate from '@/framework/logic/shared/interpolate';
import { makeValidated } from '@/framework/logic/shared/utils';
import get from '@/utils/lodash-alternatives';

import hideLayoutComponent from './hideLayoutComponent';
import initLayout from './initLayout';
import mergeLayoutProperty from './mergeLayoutProperty';
import setComponentChildren from './setComponentChildren';
import setComponentsMap from './setComponentsMap';
import setLayoutProperty from './setLayoutProperty';
import showLayoutComponent from './showLayoutComponent';

const mapChildAction = (context, event, meta) => {
  const type = get(meta, 'action.type');
  const supportedActions = {
    initLayout,
    setLayoutProperty,
    mergeLayoutProperty,
    showLayoutComponent,
    hideLayoutComponent,
    setComponentChildren,
    setComponentsMap,
  };
  if (supportedActions[type] === undefined) {
    throw new Error(
      `Action type "${type}" is not supported by "batchLayoutOperations".`
    );
  }
  const supportedAction = supportedActions[type];
  return supportedAction(context, event, meta);
};

const mapBatchLayoutOperations = action => ({
  type: 'LAYOUT_BATCH',
  payload: action.data,
});

const validated = makeValidated(schema);

const pureBatchLayoutOperations = (context, event, meta) => {
  const action = validated(interpolate(meta.action, event, context));
  return mapBatchLayoutOperations({
    type: action.type,
    data: (action.data || []).map(childAction =>
      mapChildAction(context, event, { action: childAction })
    ),
    meta: action.meta,
  });
};

export default pureBatchLayoutOperations;
